import React from "react";
import { Box, Typography } from "@mui/material";

const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#f5f5f5",
        pb: 3,
        px: "50px",
        "@media (max-width: 1360px)": {
          px: "16px",
        },
        marginTop: "-40px"
      }}
    >
      {/* Bottom Section */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          "@media (max-width: 856px)": {
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 2,          
          },
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: "14px",
              color: "#000",
              mb: 0.5,
            }}
          >
            © 2025 R3PLAY LLC
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
              color: "#000",
            }}
          >
            All rights reserved
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
